export const RumFeature = {
    AutoApply: 'auto-apply',
    AutoApplySetup: 'auto-apply-setup',
} as const;

export const REDACTED_RUM_FEATURES = new Set<string>(Object.values(RumFeature));
